import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import liff from '@line/liff';
import { linelogindomain, baseurl } from '@/config';

const login = () => import('@/views/LoginV2.vue');
const error = () => import('@/views/Error.vue');
const checktrdlogin = () => import('@/views/CheckThirdLogin.vue');
const thirdlogin = () => import('@/views/ThirdLogin.vue');
const uriBindLoadingV2 = () => import('@/components/sso2.0/UriBindLoading.vue');
const addingLineFriendV2 = () => import('@/views/AddingLineFriendV2.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login',
    name: 'index'
  },
  {
    path: '/login',
    name: 'loginV2',
    component: login,
    beforeEnter: (to, from, next) => {
      const { userAgent } = navigator;
      const possibleRedirect = 'about:blank';
      const redirectUrl = window.location.href == null ? possibleRedirect : encodeURIComponent(window.location.href.split('&liffClientId')[0].split('&friendship_status_changed')[0]);

      // 處理LIFF網址參數，LIFF跳轉機制可參考 https://developers.line.biz/en/docs/liff/opening-liff-app/#create-a-liff-url
      let membersourceQuery = {};
      const liffState = to.query['liff.state'];
      // 若有liff.state參數，表示是LIFF第一次跳轉
      if (liffState) {
        const args = liffState.split('?')[1].split('&');
        const temp = [];
        for (let i = 0; i <= args.length - 1; i += 1) {
          temp[args[i].split('=')[0]] = args[i].split('=')[1];
        }

        membersourceQuery = {
          companyid: temp.companyid,
          membersourceid: temp.membersourceid,
          membersourcepairno: temp.membersourcepairno
        };
      // 否則就是LIFF第二次跳轉 or 非LIFF
      } else {
        membersourceQuery = {
          companyid: to.query.companyid,
          membersourceid: to.query.membersourceid,
          membersourcepairno: to.query.membersourcepairno
        };
      }

      if ((!membersourceQuery.companyid || !membersourceQuery.membersourceid) && !membersourceQuery.membersourcepairno) {
        next({
          name: 'errorPage',
          query: { error: 'pleasetryagainlater' }
        });
        return;
      }

      let getMemberSourceData;

      // 若有memberSourcePairNo，用memberSourcePairNo取得MemberSource資料
      if (membersourceQuery.membersourcepairno) {
        store.commit('common/setCommonData', { id: 'memberSourcePairNo', value: membersourceQuery.membersourcepairno });
        getMemberSourceData = store.dispatch('memberSource/getMemberSourcePair').then(res => res.data[0].mainMemberSourceInfo);
      } else {
        store.commit('common/setCommonData', { id: 'companyID', value: membersourceQuery.companyid });
        store.commit('common/setCommonData', { id: 'memberSourceID', value: membersourceQuery.membersourceid });
        store.commit('common/setCommonData', { id: 'bindingMemberSourceID', value: membersourceQuery.membersourceid });
        getMemberSourceData = store.dispatch('memberSource/getMemberSourceSetting').then(res => res.data[0]);
      }
      window.onload = liff.init;
      getMemberSourceData.then(() => {
      // 2.0流程
      // 若為Line瀏覽器或LIFF，且有LIFF ID，走Line Bind流程
        if (userAgent.indexOf('Line') > -1 && store.state.memberSource.liffId) {
          store.commit('memberSource/setMemberSourceData', { id: 'isLineBrowser', value: true });
          liff.init({ liffId: store.state.memberSource.liffId }).then(() => {
            if (!liff.isInClient() && !liff.isLoggedIn()) {
              liff.login({ redirectUri: window.location.href });
            } else {
              liff.getFriendship().then((res) => {
                if (res.friendFlag) {
                  liff.getProfile().then((r) => {
                    localStorage.setItem('openID', r.userId);
                    store.commit('memberSource/setMemberSourceData', { id: 'openID', value: r.userId });
                    next();
                  });
                } else {
                  next({ name: 'addingLineFriendV2' });
                }
              });
            }
          }).catch(() => {
            liff.openWindow({
              url: window.location.href,
              external: true
            });
          });
        } else {
          next();
        }
      }).catch(() => {
        if (to.query.linebind && !to.query.code && !store.state.memberSource.openID) {
          const lineLoginUrl = linelogindomain;
          window.location.href = `${lineLoginUrl}api/v1/linecode?DirectUrl=${redirectUrl.replace('checktrdlogin', 'login')}&CompanyId=${to.query.companyid}&MemberSourceId=${to.query.membersourceid}`;
        } else if (to.query.linebind && (to.query.code || store.state.memberSource.openID)) {
          next({ name: 'uriBindLoadingV2', query: to.query });
        } else {
          if (to.query.op) {
            store.commit('memberSource/setMemberSourceData', { id: 'openID', value: to.query.op });
          }
          delete to.query.op;
          next();
        }
      });
    }
  },
  {
    path: '/checktrdlogin',
    name: 'checktrdlogin',
    component: checktrdlogin,
    beforeEnter: (to, from, next) => {
      if (to.query.redirect_url && to.query.redirect_url.indexOf('://') > -1) {
        const { query } = to;

        query.redirect_url = encodeURIComponent(encodeURIComponent(to.query.redirect_url));

        next({ name: to.name, query });
      } else {
        next();
      }
    }
  },
  {
    path: '/errorPage',
    name: 'errorPage',
    component: error
  },
  {
    path: '/uriBindLoadingV2',
    name: 'uriBindLoadingV2',
    component: uriBindLoadingV2
  },
  {
    path: '/addingLineFriendV2',
    name: 'addingLineFriendV2',
    component: addingLineFriendV2
  },
  {
    path: '/thirdlogin',
    name: 'thirdlogin',
    component: thirdlogin,
    beforeEnter: (to, from, next) => {
      const url = window.location.href;
      if (url.indexOf('thirdlogin?#') > 0) { window.location.href = window.location.href.replace('thirdlogin?#', 'thirdlogin?trdlogintype=facebook&'); }
      if (url.indexOf('thirdlogin#') > 0) { window.location.href = window.location.href.replace('thirdlogin#', 'thirdlogin?trdlogintype=google&'); }
      next();
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: baseurl,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (from.name !== to.name) {
      if (savedPosition) {
        return savedPosition;
      }
      return { x: 0, y: 0 };
    }
    return false;
  }
});

export default router;
